import yup from "src/utils/yup/extensionMethods";

const changeResponsibleOrAuthoritySchema = (translate: Function) => yup.object().shape({
	actions: yup.boolean(), 
	indicators: yup.boolean(),  
	meetings: yup.boolean(), 
	occurrences: yup.boolean(), 
	projects: yup.boolean(),  
	risks: yup.boolean() ,
	type: yup.string().oneOf(["R", "A", "B"]),
	newUser: yup.number().required(translate("O novo usuário é requerido")) 
});


export default changeResponsibleOrAuthoritySchema;
